import DOMPurify from 'dompurify';

/**
 * Sanitizes an HTML string, stripping scripts and event handlers.
 * Use this wherever content is rendered with v-html, even if the
 * backend already sanitizes the input.
 *
 * @param {string|null|undefined} html
 * @returns {string}
 */
export function sanitize(html) {
    if (!html) {
        return '';
    }

    return DOMPurify.sanitize(html);
}
